export interface EnrollmentField {
    FieldCode: string
    FieldValue: string
}

export interface EnrollmentFieldEapp {
    FieldCode: string
    FieldValue: string
    OrgID: string
}

export enum EnrollmentFieldCodes {
    ACCHOLDERNAME = 'ACCHOLDERNAME',
    ACCOUNTNB = 'ACCOUNTNB',
    AGENTEMAIL = 'AGENTEMAIL',
    AGENTFN = 'AGENTFN',
    AGENTID = 'AGENTID',
    AGENTLN = 'AGENTLN',
    APPADD1 = 'APPADD1',
    APPADD2 = 'APPADD2',
    APPCITY = 'APPCITY',
    APPDOB = 'APPDOB',
    APPDT = 'APPDT',
    APPEMAIL = 'APPEMAIL',
    APPFN = 'APPFN',
    APPGEN = 'APPGEN',
    APPLN = 'APPLN',
    APPMI = 'APPMI',
    APPST = 'APPST',
    APPZIP = 'APPZIP',
    ATESTPROOF = 'ATESTPROOF',
    AUTHREPADD1 = 'AUTHREPADD1',
    AUTHREPADD2 = 'AUTHREPADD2',
    AUTHREPCITY = 'AUTHREPCITY',
    AUTHREPIND = 'AUTHREPIND',
    AUTHREPNAME = 'AUTHREPNAME',
    AUTHREPPHONE = 'AUTHREPPHONE',
    AUTHREPREL = 'AUTHREPREL',
    AUTHREPST = 'AUTHREPST',
    AUTHREPZIP = 'AUTHREPZIP',
    APPPHONE = 'APPPHONE',
    CELLPHONE = 'CELLPHONE',
    COBBIN = 'COBBIN',
    COBEFFDT = 'COBEFFDT',
    COBPCN = 'COBPCN',
    COBTERMDT = 'COBTERMDT',
    COMPLETEIND = 'COMPLETEIND',
    CONF = 'CONF',
    CONTRACT = 'CONTRACT',
    CUID = 'CUID',
    CULTURE = 'CULTURE',
    EFFDT = 'EFFDT',
    EFTTYPE = 'EFTTYPE',
    ELECTION = 'ELECTION',
    FININSTNAME = 'FININSTNAME',
    HICN = 'HICN',
    LANG = 'LANG',
    LEGREPEMAIL = 'LEGREPEMAIL',
    LTCFACILITY = 'LTCFACILITY',
    LTCPHONE = 'LTCPHONE',
    MAILADD1 = 'MAILADD1',
    MAILADD2 = 'MAILADD2',
    MAILCITY = 'MAILCITY',
    MAILST = 'MAILST',
    MAILZIP = 'MAILZIP',
    MEDA = 'MEDA',
    MEDB = 'MEDB',
    NOTES = 'NOTES',
    OTHCVRG = 'OTHCVRG',
    OTHCVRGGRP = 'OTHCVRGGRP',
    OTHCVRGID = 'OTHCVRGID',
    OTHCVRGNAME = 'OTHCVRGNAME',
    PLANNAME = 'PLANNAME',
    PLANST = 'PLANST',
    PLANTYPE = 'PLANTYPE',
    PLANYEAR = 'PLANYEAR',
    POA = 'POA',
    PWO = 'PWO',
    ROUTINGNB = 'ROUTINGNB',
    SEPEFFDT = 'SEPEFFDT',
    SEPREASONCD = 'SEPREASONCD',
    SOA = 'SOA',
    SUFFIX = 'SUFFIX',
    TITLE = 'TITLE',
    DEX = 'DEX',
    AGENTDEX = 'AGENTDEX',
    APPSIGNEDIND = 'APPSIGNEDIND',
    AUTHREPSIGNEDIND = 'AUTHREPSIGNEDIND',
    ADMINID = 'ADMINID',
    LEADTYPE = 'LEADTYPE',
    CONTACTTYPE = 'CONTACTTYPE',
    DATEOFRECEIPT = 'RECPDT',
    POVERIND = 'POVERIND',
    CC = 'CC',
    UNMTHS = 'UNMTHS',
    SECMBRID = 'SECMBRID',
    RELCD = 'RELCD',
    FAMILYID = 'FAMILYID',
    PERSONCD = 'PERSONCD',
    LANGFORMAT = 'LANGFORMAT',
    ENROLLEEWORKSTATUS = 'ENROLLEEWORKSTATUS',
    SPOUSEWORKSTATUS = 'SPOUSEWORKSTATUS',
    AUTHREPCOPYIND = 'AUTHREPCOPYIND',
    CHANNELID = 'CHANNELID',
    STEEREDIND = 'STEEREDIND',
    EOB = 'EOB',
    EligibilityReasons = 'EligibilityReasons',
    EligibilityDate = 'EligibilityDate',
    EnrollmentMethod = 'EnrollmentMethod',
    SOAIncluded = 'SOAIncluded',
    SOANOTINCLUDEDMAIL = 'SOANOTINCLUDEDMAIL',
    MAILINGADDRESSISSAME = 'MailingAddressIsSame',
    AGENTSIGNATURE = 'AgentSignature',
    RECPDT = 'RECPDT',
    ELECTAPPID = 'ELECTAPPID',
    LTCADD1 = 'LTCADD1',
    EMERNAME = 'EMERNAME',
    EMERPHONE = 'EMERPHONE',
    EMERREL = 'EMERREL',
    EMERIND = 'EMERIND',
    CAREFAC = 'CAREFAC',
    LTCIND = 'LTCIND',
    AUTHREPEMAIL = 'AUTHREPEMAIL',
    DISENROLLIND = 'DISENROLLIND',
    DISENROLLDATE = 'DISENROLLDATE',
    DISENROLLNOTICEDT = 'DISENROLLNOTICEDT',
    DISENROLLREASONCD = 'DISENROLLREASONCD',
    DISENROLLTYPE = 'DISENROLLTYPE',

    SECCARRIER = 'SECCARRIER',
    SECACCOUNT = 'SECACCOUNT',
    SECGROUP = 'SECGROUP',

    EXTERNALID = 'EXTERNALID',
    CAREQUAL = 'CAREQUAL',
    CARRIER = 'CARRIER',
    ACCOUNT = 'ACCOUNT',
    GROUP = 'GROUP',

    ETHNICITY = 'ETHNICITY',
    RACE = 'RACE',

    GENDERNPRONOUNOTH = 'GENDERNPRONOUNOTH',
    CURRENTGENDEROTH = 'CURRENTGENDEROTH',
    // SEXATBIRTHOTH ='SEXATBIRTHOTH',
    GENDERNPRONOUN = 'GENDERNPRONOUN',
    CURRENTGENDER = 'CURRENTGENDER',
    //SEXATBIRTH='SEXATBIRTH',

    //Relationship to Enrollee
    INDREPNAME = 'INDREPNAME',
    RELTOENROLL = 'RELTOENROLL',
    NPN = 'NPN',
    INDREPIND = 'INDREPIND',
    PRIORID ='PRIORID'
}
